import React from "react";
// import { Modal } from "antd";
import {Button, Modal} from "antd";
import styles from "./IncomingCallModal.module.scss";
import crossIcon from "../../../assets/png/crossIcon.png";

import {PhoneFilled} from '@ant-design/icons';

function IncomingCallModal(props: any) {

    return (
        <Modal
            // title="People"
            open={props.isOpen}
            // onCancel={() => props.handleRejectCall()}
            centered
            className={styles.modalOveride}
        >
            <div
                 className={styles.closeBtn}
                 style={{ backgroundImage: `url(${crossIcon})` }}
                 onClick={props.handleRejectCall}
            />
            <div className={styles.boxCreate}>
                <div style={{ display: "flex", marginBottom: '24px' }}>
                    <div className={styles.textUpload}>Incoming call</div>
                </div>
                <div className={styles.incomingCallDetails}>
                    <div className={styles.incomingCallUserImg}>
                        <img className={styles.CallImage} src={props.imageProfileURL} />
                    </div>
                    <div className={styles.incomingCallUserDetails}>
                        <div className={styles.callingUser}>{props.displayName} is calling you</div>
                        <div>The call will start when you answer the call.</div>
                    </div>
                </div>
                <div className={styles.btnContainer}>
                    <Button className={styles.rejectBtn} onClick={props.handleRejectCall} danger>Reject</Button>
                    <Button className={styles.acceptBtn} icon={<PhoneFilled />} type="primary" onClick={props.handleAcceptCall}>Accept</Button>
                </div>
            </div>
        </Modal>
    );
}

export default IncomingCallModal;